<template>
  <div class="activebox">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div class="content" v-for="item in list" :key="'list_' + item.id">
      <router-link :to="{name: 'LexusActiveInfo',params:{id:item.id}}">
        <div class="pd-20">
          <div class="title mb-10">
            <van-tag v-if="item.state.id==1" class="active" type="success">{{item.state.name}}</van-tag>
            <van-tag v-if="item.state.id==2" class="active" type="danger">{{item.state.name}}</van-tag>
            <van-tag v-if="item.state.id==3" class="active">{{item.state.name}}</van-tag>
            {{item.title}}
          </div>
          <div class="sourtime mb-10">时间：{{item.start}}---{{item.end}}</div>
          <div class="sourtime mb-10">联系人：{{item.author}}</div>
        </div>
        <img class="activepic" v-lazy="item.pic?item.pic:img.default">
        <div class="pd-20">
          <van-steps :active="item.state.id" :active-icon="img.mycircle" inactive-icon="circle" active-color="#EC8075">
            <van-step>
              <div>发起</div>
              <div>{{item.start.substr(5,10)}}</div>
            </van-step>
            <van-step>审核中</van-step>
            <van-step>活动中</van-step>
            <van-step>
             <div>结束</div>
             <div>{{item.end.substr(5,10)}}</div>
           </van-step>
         </van-steps>
       </div>
     </router-link>
   </div>
 </van-list>
</div>
</template>
<script>
  import common from '../../../api/common';
  import active from '../../../api/lexus/active';
  import { mapState } from 'vuex';
  import { Step, Steps, Tag,Icon,List } from 'vant';
  export default {
    data () {
      return {
        loading: false,
        finished: false,
        params:{
          brand_id:1,
          page:1,
          size:4
        },
        list:[],
        img:{
          mycircle: require('../../../assets/img/lexus/my/mycircle.png'),
          default: require('../../../assets/img/default_lexus.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '我的活动',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyActive.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      onLoad(){
        setTimeout(() => {
          active.getMyActive(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data.data)
            this.params.page += 1
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      },
    },
    components: {
      [Step.name]:Step,
      [Steps.name]:Steps,
      [Tag.name]: Tag,
      [Icon.name]:Icon,
      [List.name]:List
    }
  }
</script>

<style lang="scss">
.activebox{
  a{
    color: #3a3a3a;
  }
  margin-top: 10px;
  .content{
    border-bottom:1px solid #f8f8f8;
    .active{
      margin-right: 5px;
    }
    .pd-20{
      padding: 0 20px;
    }
    .mb-10{
      margin-bottom: 10px;
    }
    .activepic{
      width: 100%;
      height: 230px;
    }
    .title{
      font-size: 15px;
      font-weight: bold;
      margin-top: 20px;
      letter-spacing: 2px;
    }
    .sourtime{
      font-size: 12px;
      color: #9A9A9A;
    }
    .van-action-sheet{
      height: 180px;
      .van-action-sheet__header{
        font-weight: bold;
        font-size: 17px;
        text-align: left;
        margin-left: 20px;
      }
      .van-hairline--bottom::after{
        border-bottom-width:0;
      }
      .van-action-sheet__content{
        margin-top: 10%;
      }
    }
    .van-step__title{
      margin-top: 50px;
    }
    .van-step--horizontal:first-child .van-step__title{
      margin-left: -6px;
    }
    .van-step--horizontal:last-child .van-step__title{
      margin-right: -6px;
    }
  }
}
</style>
